import React from "react";
import "./Header.css";
import { Avatar, Button, Persona, ProgressBar } from "@fluentui/react-components";
import { AlertBadgeRegular, DiversityFilled, SearchRegular, ArrowForward20Regular, ChevronRightRegular } from "@fluentui/react-icons";


const Header: React.FC = () => {
    const [count, setCount] = React.useState(45);
    return (
        <>
        <div className="cass-hurin">
               <div className="flex-1">
                <div className="fuw832nY">
                    <Persona
                    name="Kevin Sturgis"
                    avatar={{
                        image: {
                        src: "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/office-ui-fabric-react-assets/persona-male.png",
                        },
                    }}
                    />
                </div>
                <div className="cdfeyi">
                    <Button className="Textwe-2mn">0/90 <ChevronRightRegular /></Button>
                </div>
               </div>
               <div className="css-Barter">
                 <ProgressBar
                 shape="rounded"
                    thickness="large"
                    value={0}
                    />
               </div>
            </div>
        </>
    )
}

export default Header;